import ENDPOINTS from "@/providers/end-points";
import requests from "@/providers/requests";
import { Integration } from "@/modules/ooc";

export default {
  namespaced: true,

  state: {
    integrationsList: [],
  },

  getters: {
    getIntegrationsList: (state: any) => state.integrationsList,
  },

  mutations: {
    SET_INTEGRATION_LIST(state: any, payload = []) {
      state.integrationsList = payload;
    },
  },

  actions: {
    /***
     * handle on get integration list
     * @param commit
     */
    async getIntegrations({ commit }: { commit: any }) {
      return await requests
        .get(`${ENDPOINTS.OOC_BASE_URL}${ENDPOINTS.OOC.INTEGRATIONS}`)
        .then((response) => response.data)
        .then(({ data }) => data.map((item) => new Integration(item)))
        .then(async (data) => {
          await commit("SET_INTEGRATION_LIST", data);
        })
        .catch(async () => {
          await commit("SET_INTEGRATION_LIST", []);
        });
    },
  },
};
